import React, { useEffect } from 'react';
import { Dialog } from "@progress/kendo-react-dialogs";

import './Login.scss';

export const Privacy = () => {
    useEffect(() => {
        const baseTitle = "OTT";
        document.title = "Privacy policy";

        if (baseTitle !== "") {
            document.title += ` | ${baseTitle}`;
        }
    }, []);

    return (
        <>
            <Dialog className="privacyPolicy">
                <h1>
                    Privacy policy
                </h1>
                <p>
                    Effective Date: February 21, 2026
                </p>
                <p>
                    1. Information We Collect
                </p>
                <p>
                    To provide and improve our services, we may collect the following categories of information now or in the future:
                </p>
                <ul>
                    <li>
                        Personally Identifiable Information (PII): Name, address, email address, age, or identification numbers.
                    </li>
                    <li>
                        Financial and Payment Information: Transactions, credit card numbers, credit ratings, financial statements, or payment history.
                    </li>
                    <li>
                        Authentication Information: Passwords, credentials, security questions, or personal identification numbers (PINs).
                    </li>
                    <li>
                        User Activity: Network monitoring, clicks, mouse position, scroll, or keystroke logging.
                    </li>
                    <li>
                        Website Content: Text, images, sounds, videos, or hyperlinks.
                    </li>
                </ul>
                <p>
                    2. How We Use Your Data
                </p>
                <p>
                    The information collected is used to maintain platform security, process transactions, and analyze user behavior to improve our services.
                </p>
                <p>
                    3. Data Disclosure
                </p>
                <p>
                    We do not sell or transfer user data to third parties. Your information is used strictly for the internal operations of our website.
                </p>
                <p>
                    4. Cookie Policy
                </p>
                <p>
                    We create and store cookies on your computer to improve site functionality. Unlike many other platforms, we do not use or access third-party cookies. All cookies used are "first-party," meaning they are generated by us and used only for your interaction with this website.
                </p>
                <p>
                    5. Data Security
                </p>
                <p>
                    We implement robust security measures to protect your data. However, please be aware that no electronic transmission or storage method is 100% secure.
                </p>
                <p>
                    6. Changes to This Policy
                </p>
                <p>
                    We may update this policy periodically. We will notify you of any changes by posting the updated version on this page.
                </p>
            </Dialog>
        </>
    );
}